import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
	name: 'timestamp'
})
export class TimestampPipe implements PipeTransform {
	transform(value: any, _args?: unknown): any {
		return moment(Number(value)).format('LL');
	}
}
